// Absolute index = position in the append-only loaded `data`; reference identity
// works even for id-less aggregate datasets where the synthetic _id is page-relative.
export const getSelectedRowIndexes = (
  data: any[],
  rowsToUse: any[]
): number[] => {
  if (rowsToUse.length === 0) return [];

  const selected = new Set(rowsToUse);
  return data.reduce<number[]>((acc, row, index) => {
    if (selected.has(row)) acc.push(index);
    return acc;
  }, []);
};
